module.exports = __webpack_public_path__ + "static/media/npm.acdb23ea.jpg";